export const TRANSACTION_TYPES = {
  CASH: 'CASH',
  LEASE: 'LEASE',
  FINANCE: 'FINANCE',
};
